import { action as createAction } from "@iva/store-utils";
import { Dispatch } from "redux";
import { GetState, ThunkResult } from "#store/types";
import { LoggingActionTypes, LogItem } from "./loggingTypes";

import { queryClient } from "#/index";

function log(event = "unspecified", payload: any = undefined): ThunkResult {
    return (dispatch: Dispatch, getState: GetState) => {
        const loggingRid = getState().uiState.rid;
        // send update to server, otherwise queue.
        const entry: LogItem = {
            timestamp: new Date(),
            rid: loggingRid,
            emitter: "pilot-frontend",
            event: event,
            payload: payload,
        };
        dispatch(createAction(LoggingActionTypes.LOG_ITEM, entry));
    };
}

function logUidUpdate(newId: string): ThunkResult {
    return (dispatch: Dispatch, getState: GetState) => {
        dispatch(
            log("rid/update", {
                newId: newId,
                oldId: getState().uiState.rid,
            })
        );
    };
}

export { log, logUidUpdate };
